import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import QRNotFoundImage from '../../../assets/images/qr_not_found.png'
import { FaLink } from 'react-icons/fa';
import { GoDownload } from 'react-icons/go';
import { MdOutlineContentCopy } from 'react-icons/md';
import RegPlayerAvatar from './RegPlayerAvatar';
const option = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
}
const EventDetails = () => {
    const { state } = useLocation();
    const event = state?.event;

    async function downloadQRCodeImage() {
        const url = `${import.meta.env.VITE_APP_BASE_URL}/event/qr-code-img/${event?.qrCodeURL}`;
        const filename = event?.qrCodeURL;
        const response = await fetch(url);
        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
    }
    function copyText(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                // console.log("Copied successfully");
            })
            .catch(err => {
                console.error("Copy failed", err);
            });
    }

    const CalendarIcon = () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    );

    const DownloadIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    );

    const [registered, setRegistered] = useState(false);
    const [copied, setCopied] = useState(false);
    const [animIn, setAnimIn] = useState(false);

    useEffect(() => {
        setTimeout(() => setAnimIn(true), 50);
    }, []);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    // console.log(event);


    // const daysUntilClose = Math.ceil((new Date("2026-05-31") - new Date()) / (1000 * 60 * 60 * 24));
    // const registrationProgress = 68;

    return (
        // <div className='sm_event_details_con'>
        //     <div className='sm_event_details_data_con'>
        //         <div className='sm_event_details_data'>
        //             <h4>Event</h4>
        //             <h3>{event?.eventName}</h3>
        //         </div>
        //         <div className='sm_event_details_data'>
        //             <h4>Event Date</h4>
        //             <h3>{new Date(event?.eventDate).toLocaleDateString('en-US', option)} </h3>
        //         </div>
        //         <div className='sm_event_details_data'>
        //             <h4>Registration Period</h4>
        //             <h5>Opens: {new Date(event?.startDate).toLocaleDateString('en-US', option)}</h5>
        //             <h5>Closes: {new Date(event?.endDate).toLocaleDateString('en-US', option)}</h5>
        //         </div>
        //         <div className='sm_event_details_data'>
        //             <h4>Event Description</h4>
        //             <h3 dangerouslySetInnerHTML={{
        //                 __html: event?.eventDesc ?? ""
        //             }}></h3>
        //         </div>
        //     </div>
        //     <div className='sm_season_card_qr_con'>
        //         {event?.qrCodeURL &&
        //             <div className='sm_season_card_action_btn_con'>
        //                 <img src={`${import.meta.env.VITE_APP_BASE_URL}/event/qr-code-img/${event?.qrCodeURL}`} alt="qr_code" />
        //                 <GoDownload onClick={downloadQRCodeImage} className='sm_season_card_qr_down_icon' />
        //             </div>
        //         }
        //         {!event?.shortUrl &&
        //             <div className='sm_season_card_btn_and_link_con'>

        //                 <div className='sm_season_card_url'>
        //                     <FaLink className='sm_season_card_url_icon' />
        //                     <a target='_blank' href={event?.shortUrl}>{event?.shortUrl}</a>
        //                     <MdOutlineContentCopy onClick={() => copyText(event?.shortUrl)} className='sm_season_card_copy_icon' />
        //                 </div>

        //             </div>}

        //     </div>
        // </div>
        <div className="page">
            <div className="bg-orb bg-orb-1" />
            <div className="bg-orb bg-orb-2" />

            <div className="container">

                <div className={`hero-title ${animIn ? "in" : ""}`}>
                    <span>{event?.eventName}</span>
                </div>

                <div className={`main-grid ${animIn ? "in" : ""}`}>
                    <div className="left-col">
                        <div className="card">
                            <div className={`status-row ${animIn ? "in" : ""}`}>
                                <span className="badge badge-live">
                                    <span className="badge-dot" />
                                    Registration Open
                                </span>
                            </div>
                            <div className="card-title">Event Details</div>
                            <div className="date-grid">
                                {event?.eventDate &&
                                    <div className="date-item">
                                        <div className="date-item-label"><CalendarIcon /> Event Date</div>
                                        <div className="date-item-value">{new Date(event?.eventDate).toLocaleDateString('en-US', option)}</div>
                                        <div className="date-item-sub">{new Date(event?.eventDate).toLocaleDateString('en-US', { weekday: 'long' })}</div>
                                    </div>}
                                {event?.startDate &&
                                <div style={{display:'flex',flexDirection:'row',gap:'20px'}}>
                                    <div className="date-item">
                                        <div className="date-item-label"><CalendarIcon /> Start Date</div>
                                        <div className="date-item-value">{new Date(event?.startDate).toLocaleDateString('en-US', option)}</div>
                                        <div className="date-item-sub">{new Date(event?.startDate).toLocaleDateString('en-US', { weekday: 'long' })}</div>
                                    </div>
                                    <div className="date-item">
                                        <div className="date-item-label"><CalendarIcon /> End Date</div>
                                        <div className="date-item-value">{new Date(event?.endDate).toLocaleDateString('en-US', option)}</div>
                                        <div className="date-item-sub">{new Date(event?.endDate).toLocaleDateString('en-US', { weekday: 'long' })}</div>
                                    </div>
                                </div>}
                                {/* <div className="date-item">
                                    <div className="date-item-label"><ClockIcon /> Duration</div>
                                    <div className="date-item-value">Full Day</div>
                                    <div className="date-item-sub">9:00 AM – 6:00 PM</div>
                                </div> */}
                            </div>
                    
                            {/* <div className="progress-bar-track">
                                <div className="progress-bar-fill" style={{ width: `${registrationProgress}%` }} />
                            </div> */}
                            {/* <div className="progress-label">
                                <span>{registrationProgress}% of period elapsed</span>
                                <span style={{ color: "#8fbd04" }}>Active</span>
                            </div> */}
                        </div>

                        <div className="card">
                            <div className="card-title">Registered Attendees</div>
                            <div className="attendee-row">
                                {/* <div className="avatar-stack">
                                    <div className="avatar avatar-1">A</div>
                                    <div className="avatar avatar-2">B</div>
                                    <div className="avatar avatar-3">C</div>
                                    <div className="avatar avatar-4">D</div>
                                    <div className="avatar" style={{ background: "#f0f5e4", color: "#7a8a6a", fontSize: "10px", border: "2px solid #fff" }}>+24</div>
                                </div> */}
                                <RegPlayerAvatar
                                    maxVisible={4}
                                    imgs={event?.profileImages}
                                    size={30}
                                />
                                <div className="attendee-text"><strong>{event?.playerIds?.length ?? 0} people</strong> registered so far</div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-title">About This Event</div>
                            <div className="description-placeholder">
                                <div className="ph-line" style={{ width: "100%" }} />
                                <div className="ph-line" style={{ width: "88%" }} />
                                <div className="ph-line" style={{ width: "94%" }} />
                                <div className="ph-line" style={{ width: "72%" }} />
                            </div>
                            <p className="description-text" style={{ marginTop: "12px" }} dangerouslySetInnerHTML={{
                                __html: event?.eventDesc ?? ""
                            }}>

                            </p>
                        </div>
                    </div>

                    <div className="right-col">
                        {event?.qrCodeURL &&
                            <div className="qr-card">
                                <div className="card-title" style={{ textAlign: "center", marginBottom: "16px" }}>Your Event QR</div>
                                <div className="qr-wrapper"> <img src={`${import.meta.env.VITE_APP_BASE_URL}/event/qr-code-img/${event?.qrCodeURL}`} alt="qr_code" /></div>
                                <div className="qr-label">Scan to register or verify</div>
                                {event?.shortUrl &&
                                    <button onClick={() => copyText(event?.shortUrl ?? '')} className="qr-download-btn"><MdOutlineContentCopy style={{ fontSize: '20px' }} /> {event?.shortUrl} </button>}
                                <br />
                                <button onClick={downloadQRCodeImage} className="qr-download-btn"><DownloadIcon /> Download QR</button>
                            </div>}

                        {/* <div className="cta-card">
                            <div className="card-title" style={{ marginBottom: "16px" }}>Registration</div>
                            <button
                                className={`register-btn ${registered ? "register-btn-registered" : "register-btn-active"}`}
                                onClick={handleRegister}
                            >
                                {registered ? <><CheckIcon /> Registered!</> : <>Register Now</>}
                            </button>
                            <button className="share-btn" onClick={handleCopy}>
                                <ShareIcon />
                                <span className={copied ? "copied-text" : ""}>{copied ? "Link Copied!" : "Share Event"}</span>
                            </button>
                            <p className="cta-note">By registering, you agree to the event's terms. A confirmation with your QR code will be emailed to you.</p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventDetails